<template>
    <div>
        <keyboard-events v-on:keyup="keyboardEvent"></keyboard-events>
        <div class="row">
            <div class="col-md-3">
                <filters-general ref="filtersReport"></filters-general>
            </div>
            <div class="col-md-9" >
                <div class="row">
                    <div class="col-md-4 text-center"></div>
                    <div class="col-md-4 text-center">
                        <button class="btn ripple btn-primary" @click="getReport">Generar Reporte </button>
                    </div>
                    <div class="col-md-4" v-if="showResult">
                        <div v-if="loadfile">
                            <img :src="'/theme/img/loads/loadfile.gif'" alt="carga archivo" height="40">
                            <p>Preparando archivo, espere...</p>
                        </div>
                        <button v-if="!loadfile"  class="btn btn-success" type="button" @click="ExportFile"><i class="fas fa-file-excel"></i> <i class="fe fe-download-cloud"></i><b> Descargar Excel.</b></button>
                    </div>
                </div><br>
                <div class="row">
                    <div class="col-md-12">
                        <div v-if="loadingGetData" class="text-center">
                            <img :src="'/theme/img/loads/loadfile.gif'" alt="carga archivo" height="40">
                            <p>Preparando información, espere...</p>
                        </div>
                    </div>
                    <div class="col-md-12" v-show="showResult">
                        <v-client-table :data="tableDataFaltantes" :columns="columnsFaltantes" :options="optionsFaltantes" class="table-responsive" ref="tableFaltantes">
                        </v-client-table>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "tablaFaltantesTienda",
    data(){
        return{
            loadfile:false,
            showResult:false,
            loadingGetData: false,
            showData: false,
            columnsFaltantes: ['Fecha','Semana','Area','Agencia','Usuario','Tipo','Rol','Estado','Ciudad','Canal','Cadena','Formato','Tienda','Fabricante','Departamento','Categoria','Marca','Codigo','Producto'],
            tableDataFaltantes: [],
            optionsFaltantes: {
                footerHeadings:false,
                filterByColumn:true,
                perPage:5,
                perPageValues: [5,10],
                filterable: ['Usuario','Tipo','Rol','Tienda','Area','Formato','Canal','Cadena','Producto'],
                sortIcon:
                    { base:'fontawesome', up:'fas fa-long-arrow-alt-up', down:'fas fa-long-arrow-alt-down', is:'fas fa-sort' }
                ,
                listColumns: {
                },
                cellClasses:{
                    InventarioF: [
                        {
                            class:'bg-danger',
                            condition: row => row.InventarioF <= 0
                        }
                    ]
                },
                columnsDropdown:false,
                headings: {
                    Id: '#',
                    Fecha: 'Fecha Hora Registro',
                    Gestor: 'Usuario',
                    Cantidad: 'Inventario Inicial Piezas',
                    Resurtido: 'Resurtido Piezas',
                    Ventas: 'Ventas Piezas',
                    InventarioF: 'Inventario Final Piezas',
                },
                columnsClasses: {
                    Id: 'text-center font-bold text-danger',
                    Producto: 'text-center',
                    Gestor: 'text-center',
                    Tienda: 'text-center',
                    Area: 'text-center',
                    Formato: 'text-center',
                    Canal: 'text-center',
                    Cadena: 'text-center',
                    Fecha: 'text-center',
                    Cantidad: 'text-center',
                    Comentario: 'text-justify',
                },
                texts: {
                    count: "Mostrando {from} al {to} de {count} registros|{count} registros|Un registro",
                    first: 'Primero',
                    last: 'Último',
                    filter: "Filtro:",
                    filterPlaceholder: "Buscar:",
                    limit: "Registros:",
                    page: "Pagína:",
                    noResults: "No hay resultados",
                    filterBy: "Filtrar",
                    loading: 'Buscando...',
                    defaultOption: 'Todos',
                    //defaultOption: 'Elige {column}',
                    columns: 'Columnas'
                },
            },
        }
    },
    mounted() {
        this.$refs.filtersReport.shows.trades = false;
    },
    methods:{
        keyboardEvent (e) {
            if (e.which === 13) {
                this.getReport();
            }
        },
        getReport(){ let $this = this;
            var filters = this.$refs.filtersReport.filters;
            if (filters.timeInit === null){
                this.$toastMessage('error',"Fecha Inicio Es Obligatoria",4000,'center');
            }else if (filters.timeEnd === null){
                this.$toastMessage('error',"Fecha Termino Es Obligatoria",4000,'center');
            }else{
                this.loadingGetData = true;
                this.showData = false;
                this.showResult = false;
                this.tableDataInventario = [];
                axios.post('/api/Faltantes/TablaTienda',{data:filters})
                    .then(r => {
                            $this.loadingGetData = false;
                            $this.showData = true;
                            $this.tableDataFaltantes = r.data.Data;
                            $this.showResult = true;
                        },
                        error => {
                            $this.$toastMessage('error','Error: ' + error +' Por favor envia este error al área de soporte!',9000,'center');
                        }
                    );
            }
        },
        ExportFile(){let $this = this;
            this.loadfile = true;
            var filters = this.$refs.filtersReport.filters;
            axios({
                method: 'post',
                url: '/api/Faltantes/exportLayoutToExcelTienda',
                responseType: 'arraybuffer',
                data: { data: filters, type: 1 }}).then(r => {
                    let blob = new Blob([r.data], { type: 'application/xlsx' })
                    let link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    link.download = 'FaltantesMoet.xlsx'
                    link.click()
                    $this.loadfile=false;
                },
                error => {
                    $this.$toastMessage('error','Error: ' + error +' Por favor envia este error al área de soporte!',9000,'center');
                    $this.loadfile=false;
                }
            );
        },
    }
}
</script>

<style scoped>

</style>
